<div class="page-container" testId="personal-broadcast-list-page">
  <div class="page-topbar" testId="personal-broadcast-list-topbar">
    <div class="page-header" testId="personal-broadcast-list-header">
      <div class="title-section" testId="personal-broadcast-list-title-section">
        <h1 testId="personal-broadcast-list-title">{{ 'personal-broadcast.list.title' | i18n }}</h1>
        <p testId="personal-broadcast-list-subtitle">{{ 'personal-broadcast.list.subtitle' | i18n: { total: recordCount } }}</p>
      </div>
      <button nz-button nzType="primary" class="create-btn" (click)="create()" testId="personal-broadcast-list-create-button">
        <i nz-icon nzType="plus"></i>
        {{ 'personal-broadcast.list.create' | i18n }}
      </button>
    </div>

    <div class="topbar-search" testId="personal-broadcast-list-search-section">
      <div class="topbar-search-row" testId="personal-broadcast-list-search-row">
        <nz-input-group [nzPrefix]="prefixIconSearch" class="search-input" testId="personal-broadcast-list-search-input-group">
          <input
            nz-input
            [placeholder]="'personal-broadcast.list.search-placeholder' | i18n"
            [(ngModel)]="keywords"
            testId="personal-broadcast-list-search-input"
          />
        </nz-input-group>
      </div>
    </div>
  </div>

  <ng-template #prefixIconSearch>
    <i nz-icon nzType="search"></i>
  </ng-template>

  <div class="page-scroll" testId="personal-broadcast-list-page-scroll">
    <nz-spin [nzSpinning]="loading && list.length === 0" testId="personal-broadcast-list-spin">
      <ng-container *ngIf="filteredList.length; else empty">
        <div class="list-scroll" (scroll)="onListScroll($event)" testId="personal-broadcast-list-scroll">
          <div class="list" testId="personal-broadcast-list">
            <nz-card
              *ngFor="let item of filteredList; let i = index"
              class="card"
              [nzBodyStyle]="{ padding: '16px' }"
              [testId]="'personal-broadcast-list-card-' + i"
            >
              <div class="broadcast-item">
                <div class="broadcast-main">
                  <div class="broadcast-title-row">
                    <div class="broadcast-title">
                      <span class="title">{{ item.title }}</span>
                      <span class="status-badge" [ngClass]="statusClass(item.status)">
                        <i nz-icon [nzType]="statusIcon(item.status)" nzTheme="outline"></i>
                        <span>{{ item.statusLabel }}</span>
                      </span>
                    </div>
                    <div class="broadcast-remark" *ngIf="false">{{ item.remark }}</div>
                    <div class="broadcast-metrics">
                      <span class="metric">
                        <i nz-icon nzType="clock-circle" nzTheme="outline"></i>
                        <span>{{ item.time }}</span>
                      </span>
                      <ng-container *ngIf="shouldShowCounts(item)">
                        <span class="metric">
                          <i nz-icon nzType="user" nzTheme="outline"></i>
                          <span> {{ 'personal-broadcast.common.people-unit' | i18n: { count: (item.expected | number) } }}</span>
                        </span>
                        <span class="metric metric-success">
                          <i nz-icon nzType="check-circle" nzTheme="outline"></i>
                          <span>{{ 'personal-broadcast.common.success' | i18n }} {{ item.success | number }}</span>
                        </span>
                        <span class="metric metric-danger">
                          <i nz-icon nzType="close-circle" nzTheme="outline"></i>
                          <span>{{ 'personal-broadcast.common.failed' | i18n }} {{ item.failed | number }}</span>
                        </span>
                      </ng-container>
                    </div>
                  </div>
                  <div class="broadcast-meta-row">
                    <div class="meta-item">
                      <span class="meta-label">{{ 'personal-broadcast.list.channel-label' | i18n }}</span>
                      <ng-container *ngIf="channelIcon(item.channel) as icon; else channelTextOnly">
                        <span class="channel-pill">
                          <img class="channel-icon" [src]="icon" [alt]="item.channel" />
                          <span class="channel-text">{{ item.channelLabel }}</span>
                        </span>
                      </ng-container>
                      <ng-template #channelTextOnly>
                        <span class="channel-pill">
                          <i nz-icon nzType="appstore" nzTheme="outline" class="channel-default-icon"></i>
                          <span class="channel-text">{{ item.channelLabel }}</span>
                        </span>
                      </ng-template>
                    </div>
                    <div class="meta-item meta-tags">
                      <span class="meta-label">{{ 'personal-broadcast.list.tag-label' | i18n }}</span>
                      <ng-container *ngIf="item.labelInfos?.length; else noTags">
                        <nz-tag *ngFor="let tag of visibleLabels(item)" class="tag">{{ tag.name }}</nz-tag>
                        <nz-tag
                          *ngIf="hiddenLabelCount(item) > 0"
                          class="tag tag-more"
                          nz-tooltip
                          [nzTooltipTitle]="hiddenLabelNames(item)"
                        >
                          +{{ hiddenLabelCount(item) }}
                        </nz-tag>
                      </ng-container>
                      <ng-template #noTags>—</ng-template>
                    </div>
                  </div>
                </div>
                <div class="broadcast-actions">
                  <button
                    *ngIf="canEdit(item)"
                    nz-button
                    nzType="default"
                    class="action-btn action-btn-edit"
                    (click)="edit(item)"
                    [testId]="'personal-broadcast-list-edit-button-' + i"
                  >
                    <i nz-icon nzType="edit" nzTheme="outline"></i>{{ 'common.edit' | i18n }}
                  </button>
                  <button
                    nz-button
                    nzType="default"
                    class="action-btn action-btn-delivery"
                    (click)="openDeliveryDrawer(item)"
                    [testId]="'personal-broadcast-list-delivery-result-button-' + i"
                  >
                    <i nz-icon nzType="unordered-list" nzTheme="outline"></i>{{ 'personal-broadcast.list.delivery-results' | i18n }}
                  </button>
                  <button
                    nz-button
                    nzType="default"
                    class="action-btn action-btn-view"
                    (click)="view(item)"
                    [testId]="'personal-broadcast-list-view-button-' + i"
                  >
                    <i nz-icon nzType="eye" nzTheme="outline"></i>{{ 'personal-broadcast.list.view-detail' | i18n }}
                  </button>
                  <span nz-tooltip [nzTooltipTitle]="canDelete(item) ? null : ('personal-broadcast.list.delete-tooltip.doing' | i18n)">
                    <button
                      nz-button
                      nzType="default"
                      nzDanger
                      class="action-btn action-btn-danger"
                      [disabled]="!canDelete(item)"
                      (click)="remove(item)"
                      [testId]="'personal-broadcast-list-delete-button-' + i"
                    >
                      <i nz-icon nzType="delete" nzTheme="outline"></i>{{ 'common.delete' | i18n }}
                    </button>
                  </span>
                </div>
              </div>
            </nz-card>
          </div>

          <div class="list-footer" *ngIf="list.length" testId="personal-broadcast-list-footer">
            <nz-spin nzSimple [nzSpinning]="loadingMore" />
            <div class="list-footer-text" *ngIf="!loadingMore">
              {{ hasMore ? ('personal-broadcast.list.scroll-more' | i18n) : ('personal-broadcast.list.no-more' | i18n) }}
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #empty>
        <nz-empty testId="personal-broadcast-list-empty" />
      </ng-template>
    </nz-spin>
  </div>
</div>

<ng-template #detailModalTitleTpl>
  <div class="detail-modal-title" *ngIf="detailModalItem as item" testId="personal-broadcast-detail-modal-title">
    <div class="detail-title-top">
      <div class="detail-title-row">
        <div class="detail-title">{{ item.title }}</div>
        <span class="status-badge" [ngClass]="statusClass(item.status)">
          <i nz-icon [nzType]="statusIcon(item.status)" nzTheme="outline"></i>
          <span>{{ item.statusLabel }}</span>
        </span>
      </div>
      <button
        nz-button
        nzType="primary"
        class="detail-title-edit"
        *ngIf="canEdit(item)"
        (click)="editFromDetail()"
        testId="personal-broadcast-detail-modal-edit-button"
      >
        <i nz-icon nzType="edit" nzTheme="outline"></i>
        <span>{{ 'common.edit' | i18n }}</span>
      </button>
    </div>
    <div class="detail-metrics">
      <span class="metric">
        <i nz-icon nzType="clock-circle" nzTheme="outline"></i>
        <span>{{ item.time }}</span>
      </span>
      <ng-container *ngIf="item.status === 'Done'">
        <span class="metric">
          <i nz-icon nzType="user" nzTheme="outline"></i>
          <span>{{ 'personal-broadcast.common.people-unit' | i18n: { count: (item.expected | number) } }}</span>
        </span>
        <span class="metric metric-success">
          <i nz-icon nzType="check-circle" nzTheme="outline"></i>
          <span>{{ 'personal-broadcast.common.success' | i18n }} {{ item.success | number }}</span>
        </span>
        <span class="metric metric-danger">
          <i nz-icon nzType="close-circle" nzTheme="outline"></i>
          <span>{{ 'personal-broadcast.common.failed' | i18n }} {{ item.failed | number }}</span>
        </span>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #deliveryDrawerTpl>
  <div class="delivery-drawer" *ngIf="deliveryDrawerItem as item" testId="personal-broadcast-delivery-drawer">
    <div class="delivery-drawer-summary" testId="personal-broadcast-delivery-summary">
      <div class="delivery-drawer-heading">
        <div class="delivery-drawer-title" testId="personal-broadcast-delivery-title">{{ item.title }}</div>
        <span class="status-badge" [ngClass]="statusClass(item.status)">
          <i nz-icon [nzType]="statusIcon(item.status)" nzTheme="outline"></i>
          <span>{{ item.statusLabel }}</span>
        </span>
      </div>
      <div class="delivery-drawer-meta">
        <span class="drawer-meta-item"><i nz-icon nzType="clock-circle" nzTheme="outline"></i>{{ item.time }}</span>
        <span class="drawer-meta-item"
          ><i nz-icon nzType="user" nzTheme="outline"></i
          >{{ 'personal-broadcast.common.people-unit' | i18n: { count: item.expected } }}</span
        >
        <span class="drawer-meta-item metric-success"
          ><i nz-icon nzType="check-circle" nzTheme="outline"></i>{{ 'personal-broadcast.common.success' | i18n }} {{ item.success }}</span
        >
        <span class="drawer-meta-item metric-danger"
          ><i nz-icon nzType="close-circle" nzTheme="outline"></i>{{ 'personal-broadcast.common.failed' | i18n }} {{ item.failed }}</span
        >
      </div>
    </div>
    <div class="delivery-results-toolbar" testId="personal-broadcast-delivery-toolbar">
      <nz-select
        class="delivery-status-select"
        [ngModel]="deliveryStatusFilter"
        (ngModelChange)="onDeliveryStatusChange($event)"
        nzAllowClear
        [nzPlaceHolder]="'personal-broadcast.detail.delivery.status-filter' | i18n"
        testId="personal-broadcast-delivery-status-select"
      >
        <nz-option nzValue="Pending" [nzLabel]="'personal-broadcast.detail.delivery.pending' | i18n" />
        <nz-option nzValue="Success" [nzLabel]="'personal-broadcast.detail.delivery.success' | i18n" />
        <nz-option nzValue="Failed" [nzLabel]="'personal-broadcast.detail.delivery.failed' | i18n" />
        <nz-option nzValue="Interrupted" [nzLabel]="'personal-broadcast.detail.delivery.interrupted' | i18n" />
      </nz-select>
      <button
        nz-button
        nzType="primary"
        class="delivery-query-btn"
        (click)="loadDeliveryResults()"
        testId="personal-broadcast-delivery-query-button"
      >
        <i nz-icon nzType="search" nzTheme="outline"></i>{{ 'personal-broadcast.detail.delivery.query' | i18n }}
      </button>
    </div>
    <nz-table
      class="delivery-results-table"
      #deliveryDrawerTable
      [nzData]="deliveryResults"
      [nzLoading]="deliveryLoading"
      [nzFrontPagination]="false"
      [nzTotal]="deliveryTotal"
      [nzPageIndex]="deliveryPageIndex"
      [nzPageSize]="deliveryPageSize"
      (nzPageIndexChange)="onDeliveryPageIndexChange($event)"
      nzSize="small"
      testId="personal-broadcast-delivery-table"
    >
      <thead>
        <tr>
          <th>{{ 'personal-broadcast.detail.delivery.customer' | i18n }}</th>
          <th>{{ 'personal-broadcast.detail.delivery.channel' | i18n }}</th>
          <th>{{ 'personal-broadcast.detail.delivery.status' | i18n }}</th>
          <th>{{ 'personal-broadcast.detail.delivery.error' | i18n }}</th>
          <th>{{ 'personal-broadcast.detail.delivery.finished-at' | i18n }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let result of deliveryDrawerTable.data; let i = index"
          [attr.data-testid]="'personal-broadcast-delivery-row-' + (result.customerId || i)"
        >
          <td>
            <div class="delivery-customer-name">{{ result.customerName || '—' }}</div>
            <div class="delivery-customer-id">{{ result.customerId }}</div>
          </td>
          <td>{{ result.channel || '—' }}</td>
          <td>
            <span class="delivery-status" [ngClass]="'delivery-status-' + (result.status || 'Pending').toLowerCase()">
              {{ deliveryStatusLabel(result.status) }}
            </span>
          </td>
          <td>{{ result.errorMessage || result.errorCode || '—' }}</td>
          <td>{{ deliveryTime(result.finishTime) }}</td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</ng-template>

<ng-template #detailModalTpl>
  <div class="detail-modal" *ngIf="detailModalItem as item" testId="personal-broadcast-detail-modal">
    <nz-spin [nzSpinning]="detailLoading">
      <div class="detail-body">
        <div class="detail-section">
          <div class="detail-section-title">{{ 'personal-broadcast.detail.section.send-info' | i18n }}</div>
          <div class="detail-kv">
            <div class="detail-k">
              <span>{{ 'personal-broadcast.detail.field.channel' | i18n }}</span>
            </div>
            <div class="detail-v">
              <ng-container *ngIf="channelIcon(item.channel) as icon; else channelTextOnly">
                <span class="channel-pill">
                  <img class="channel-icon" [src]="icon" [alt]="item.channel" />
                  <span class="channel-text">{{ item.channelLabel }}</span>
                </span>
              </ng-container>
              <ng-template #channelTextOnly>
                <span class="channel-pill">
                  <i nz-icon nzType="appstore" nzTheme="outline" class="channel-default-icon"></i>
                  <span class="channel-text">{{ item.channelLabel }}</span>
                </span>
              </ng-template>
            </div>
          </div>
          <div class="detail-kv">
            <div class="detail-k">
              <span>{{ 'personal-broadcast.detail.field.customer-tags' | i18n }}</span>
            </div>
            <div class="detail-v">
              <ng-container *ngIf="item.labelInfos?.length; else noDetailTags">
                <nz-tag *ngFor="let tag of item.labelInfos" class="tag">{{ tag.name }}</nz-tag>
              </ng-container>
              <ng-template #noDetailTags>—</ng-template>
            </div>
          </div>
        </div>

        <div class="detail-section">
          <div class="detail-section-title">{{ 'personal-broadcast.detail.section.messages' | i18n }}</div>
          <ng-container *ngIf="detailMessages.length; else emptyDetailMsg">
            <div class="detail-msg-scroll">
              <div class="detail-msg-list">
                <div class="detail-msg-item" *ngFor="let msg of detailMessages">
                  <div class="detail-msg-icon">
                    <ng-container [ngSwitch]="$any(msg).type">
                      <i *ngSwitchCase="'text'" nz-icon nzType="message" nzTheme="outline"></i>
                      <i *ngSwitchCase="'image'" nz-icon nzType="picture" nzTheme="outline"></i>
                      <i *ngSwitchCase="'file'" nz-icon nzType="file" nzTheme="outline"></i>
                      <i *ngSwitchCase="'template'" nz-icon nzType="appstore" nzTheme="outline"></i>
                      <i *ngSwitchDefault nz-icon nzType="question-circle" nzTheme="outline"></i>
                    </ng-container>
                  </div>
                  <div class="detail-msg-body">
                    <ng-container [ngSwitch]="$any(msg).type">
                      <div *ngSwitchCase="'text'" class="detail-msg-text">{{ $any(msg).text }}</div>
                      <div *ngSwitchCase="'image'" class="detail-msg-file">
                        <div class="detail-preview">
                          <a
                            *ngIf="$any(msg).url || $any(msg).thumbnailUrl; else noImagePreview"
                            class="detail-preview-link"
                            [href]="$any(msg).url || $any(msg).thumbnailUrl"
                            target="_blank"
                            rel="noopener"
                            testId="personal-broadcast-list-detail-image-preview-link"
                          >
                            <img class="detail-preview-image" [src]="$any(msg).thumbnailUrl || $any(msg).url" [alt]="$any(msg).name" />
                          </a>
                          <ng-template #noImagePreview>
                            <div class="detail-preview-placeholder">{{ 'personal-broadcast.detail.image.no-preview' | i18n }}</div>
                          </ng-template>
                        </div>
                        <div class="detail-msg-name">{{ $any(msg).name }}</div>
                        <div class="detail-msg-meta">{{ formatFileSize($any(msg).size) }}</div>
                      </div>
                      <div *ngSwitchCase="'file'" class="detail-msg-file">
                        <div class="detail-file-row">
                          <i nz-icon nzType="paper-clip" nzTheme="outline"></i>
                          <a
                            *ngIf="$any(msg).url; else fileNameOnly"
                            class="detail-link"
                            [href]="$any(msg).url"
                            target="_blank"
                            rel="noopener"
                            testId="personal-broadcast-list-detail-file-link"
                          >
                            {{ $any(msg).name }}
                          </a>
                          <ng-template #fileNameOnly>
                            <span class="detail-file-name">{{ $any(msg).name }}</span>
                          </ng-template>
                        </div>
                        <div class="detail-msg-meta">{{ formatFileSize($any(msg).size) }}</div>
                      </div>
                      <div *ngSwitchCase="'template'" class="detail-msg-template">
                        <div class="template-card">
                          <div class="template-text">
                            <div class="detail-msg-name">{{ $any(msg).title }}</div>
                            <div class="detail-msg-meta" *ngIf="$any(msg).subtitle">{{ $any(msg).subtitle }}</div>
                          </div>
                          <div class="template-image-wrap" *ngIf="$any(msg).imageUrl">
                            <a
                              class="detail-preview-link"
                              [href]="$any(msg).imageUrl"
                              target="_blank"
                              rel="noopener"
                              testId="personal-broadcast-list-detail-template-image-link"
                            >
                              <img class="template-image" [src]="$any(msg).imageUrl" [alt]="$any(msg).title" />
                            </a>
                          </div>
                          <div class="template-buttons" *ngIf="$any(msg).buttonTexts?.length">
                            <span class="template-btn" *ngFor="let btn of $any(msg).buttonTexts">{{ btn }}</span>
                          </div>
                        </div>
                      </div>
                      <div *ngSwitchDefault class="detail-msg-meta">
                        {{ 'personal-broadcast.detail.message.unknown-type' | i18n: { type: $any(msg).rawType } }}
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #emptyDetailMsg>
            <div class="detail-empty">—</div>
          </ng-template>
        </div>
      </div>
      <!-- delivery results are shown in the dedicated drawer -->
      <div class="detail-section delivery-results-section" *ngIf="false">
        <div class="detail-section-title">{{ 'personal-broadcast.detail.section.delivery-results' | i18n }}</div>
        <div class="delivery-results-toolbar">
          <nz-select
            [ngModel]="deliveryStatusFilter"
            (ngModelChange)="onDeliveryStatusChange($event)"
            nzAllowClear
            [nzPlaceHolder]="'personal-broadcast.detail.delivery.status-filter' | i18n"
            testId="personal-broadcast-detail-modal-delivery-status-filter"
          >
            <nz-option nzValue="Pending" [nzLabel]="'personal-broadcast.detail.delivery.pending' | i18n" />
            <nz-option nzValue="Success" [nzLabel]="'personal-broadcast.detail.delivery.success' | i18n" />
            <nz-option nzValue="Failed" [nzLabel]="'personal-broadcast.detail.delivery.failed' | i18n" />
            <nz-option nzValue="Interrupted" [nzLabel]="'personal-broadcast.detail.delivery.interrupted' | i18n" />
          </nz-select>
          <button nz-button nzType="default" (click)="loadDeliveryResults()" testId="personal-broadcast-detail-modal-delivery-query-button">
            <i nz-icon nzType="search" nzTheme="outline"></i>{{ 'personal-broadcast.detail.delivery.query' | i18n }}
          </button>
        </div>
        <nz-table
          #deliveryTable
          [nzData]="deliveryResults"
          [nzLoading]="deliveryLoading"
          [nzFrontPagination]="false"
          [nzTotal]="deliveryTotal"
          [nzPageIndex]="deliveryPageIndex"
          [nzPageSize]="deliveryPageSize"
          (nzPageIndexChange)="onDeliveryPageIndexChange($event)"
          nzSize="small"
          testId="personal-broadcast-detail-modal-delivery-results-table"
        >
          <thead
            ><tr>
              <th>{{ 'personal-broadcast.detail.delivery.customer' | i18n }}</th>
              <th>{{ 'personal-broadcast.detail.delivery.channel' | i18n }}</th>
              <th>{{ 'personal-broadcast.detail.delivery.status' | i18n }}</th>
              <th>{{ 'personal-broadcast.detail.delivery.error' | i18n }}</th>
              <th>{{ 'personal-broadcast.detail.delivery.finished-at' | i18n }}</th>
            </tr></thead
          >
          <tbody
            ><tr *ngFor="let result of deliveryTable.data">
              <td>{{ result.customerId }}</td>
              <td>{{ result.channel || '—' }}</td>
              <td>{{ deliveryStatusLabel(result.status) }}</td>
              <td>{{ result.errorMessage || result.errorCode || '—' }}</td>
              <td>{{ deliveryTime(result.finishTime) }}</td>
            </tr></tbody
          >
        </nz-table>
      </div>
    </nz-spin>
  </div>
</ng-template>
